// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.auth {
  max-width: 824px;
}
.auth .form-floating:focus-within {
  z-index: 2;
}
.auth-input-group {
  max-width: 380px;
}
.auth-button {
  max-width: 320px;
}`, "",{"version":3,"sources":["webpack://./assets/scss/auth/common.scss","webpack://./assets/scss/auth/forgot.scss"],"names":[],"mappings":"AAAA;;EAEI,YAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;ADCI;EACI,UAAA;ACCR;ADEI;EACI,gBAAA;ACAR;ADGI;EACI,gBAAA;ACDR","sourcesContent":["html,\nbody {\n    height: 100%;\n}\n\n.auth {\n    max-width: 824px;\n\n    .form-floating:focus-within {\n        z-index: 2;\n    }\n\n    &-input-group {\n        max-width: 380px;\n    }\n\n    &-button {\n        max-width: 320px;\n    }\n}","html,\nbody {\n  height: 100%;\n}\n\n.auth {\n  max-width: 824px;\n}\n.auth .form-floating:focus-within {\n  z-index: 2;\n}\n.auth-input-group {\n  max-width: 380px;\n}\n.auth-button {\n  max-width: 320px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
